import React, { Component } from 'react';
import { Icons } from '../../../../utilities';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { string } from '../../../../localization';
import * as actions from '../../../../redux/sideBarActions';
import { setMessageDialogParams } from '../../../../redux/fabricCanvasActions';
import PointedSeparator from '../../../../UI/PointedSeparater/PointedSeparator';
import {
  Label,
  Input,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu
} from 'reactstrap';
import ReactSelect, { components } from 'react-select';
import '../../SideBarContainer.scss';
import './FinishingDetails.scss';
import * as Constants from '../../../../utilities/constants/Constants';
import MediaQuery from 'react-responsive';

class FinishingDetails extends Component {
  state = {
    activeOption: null,
    frameColor: 'none'
  };

  componentDidMount() {
    this.setDefaults();
  }

  componentDidUpdate(prevProps) {
    const { canvasFrameColor } = this.props;

    if (prevProps.canvasFrameColor != canvasFrameColor) {
      this.setState({ frameColor: canvasFrameColor });
    }
  }

  setDefaults = () => {
    const { canvasFrameType, canvasFrameColor } = this.props;
    const frameType =
      canvasFrameType !== null
        ? canvasFrameType
        : Constants.CANVAS_FRAME_TYPE_MIRROR;
    this.setState({
      activeOption: frameType
    });
    if (canvasFrameColor) {
      this.setState({
        frameColor: canvasFrameColor
      });
    }
  };

  setActiveOption = option => {
    this.setState({
      activeOption: option
    });
  };

  setFrameColor = value => {
    let colorValue = value;
    if (colorValue.substr(0, 1) == '#') colorValue = colorValue.substr(1);
    this.setState({
      frameColor: colorValue
    });
  };

  getMatchedColorIndex = (colorArray, inColor) => {
    let activeColor = inColor;
    let matchedIndex = 0;
    colorArray.forEach((iColor, index) => {
      let color = iColor;
      if (color.substr(0, 1) == '#') color = color.substr(1);
      if (activeColor.substr(0, 1) == '#') activeColor = activeColor.substr(1);
      if (color === activeColor) {
        matchedIndex = index;
      }
    });
    return matchedIndex;
  };

  showFinishingChoiceAppliedDialog = () => {
    const { showDialog } = this.props;
    const dict = {
      header: '',
      description: 'Finishing choice applied.',
      stringColor: Constants.DEFAULT_STRING_COLOR,
      onclick: null,
      buttonTitles: {
        finish: string.OK_KEY,
        cancel: ''
      }
    };
    showDialog(dict);
  };

  handleApply = () => {
    const { activeOption, frameColor } = this.state;
    const { dispatchers } = this.props;
    dispatchers.setCanvasFrameType(activeOption);
    this.showFinishingChoiceAppliedDialog();
    if (activeOption === Constants.CANVAS_FRAME_TYPE_SOLID_COLOR) {
      dispatchers.setCanvasFrameColor(frameColor);
    }
  };

  render() {
    const { defaultColors, dispatchers } = this.props;
    const { frameColor, activeOption } = this.state;

    const finishingOptions = [
      {
        name: string.MIRROR_KEY,
        alt_text: 'mirror-icon',
        tab_id: Constants.CANVAS_FRAME_TYPE_MIRROR,
        img_url: Icons.canvasFrameTypeExtend
      },
      {
        name: string.NATURAL_KEY,
        alt_text: 'natural-icon',
        tab_id: Constants.CANVAS_FRAME_TYPE_EXTEND,
        img_url: Icons.canvasFrameTypeMirror
      },
      {
        name: string.SOLID_COLOR_KEY,
        alt_text: 'solid-color-icon',
        tab_id: Constants.CANVAS_FRAME_TYPE_SOLID_COLOR,
        img_url: Icons.canvasFrameTypeSolidColor
      }
    ];
    const getActiveOrNormalOptionClass = option => {
      if (activeOption === option) {
        return 'finishing-material finishing-material-focused';
      }
      return 'finishing-material';
    };

    const getActiveOrNormalApplyButtonClass = () => {
      if (
        activeOption === Constants.CANVAS_FRAME_TYPE_MIRROR ||
        activeOption === Constants.CANVAS_FRAME_TYPE_EXTEND ||
        (activeOption === Constants.CANVAS_FRAME_TYPE_SOLID_COLOR &&
          frameColor !== 'none')
      ) {
        return 'button button-active';
      }
      return 'button';
    };

    const Option = props => {
      const { innerProps, innerRef } = props;
      return (
        <div ref={innerRef} {...innerProps} style={{ padding: '2px 5px' }}>
          <img alt={props.data.name} src={props.data.thumbnail_path} />
        </div>
      );
    };
    const SingleValue = ({ children, ...props }) => (
      <components.SingleValue {...props}>
        <span className='selected-font'>{props.data.name}</span>
      </components.SingleValue>
    );

    const IndicatorSeparator = ({ innerProps }) => (
      <span
        style={{
          alignSelf: 'stretch',
          backgroundColor: 'rgb(110, 111, 113)',
          marginBottom: 0,
          marginTop: 0,
          width: 2
        }}
        {...innerProps}
      />
    );

    const solidColorIndex = this.getMatchedColorIndex(
      defaultColors,
      frameColor
    );
    return (
      <div className=' h-100 text-left '>
        <MediaQuery query='(min-width: 576px)'>
          <PointedSeparator tab='second-tab' separatorMargin />
        </MediaQuery>
        <MediaQuery query='(max-width: 576px)'>
          <hr style={{ background: '#7f7f7f', marginLeft: '5px' }} />
        </MediaQuery>

        <div className='finishing-tab-margin'>
          <div className=' d-flex mb-4'>
            {finishingOptions.map(option => (
              <div
                key={option.tab_id}
                className='d-flex flex-column finishing-options-margin'
              >
                <div
                  className={getActiveOrNormalOptionClass(option.tab_id)}
                  onClick={() => {
                    this.setActiveOption(option.tab_id);
                  }}
                  onKeyPress={() => {}}
                  role='button'
                  tabIndex='0'
                >
                  <div>
                    <img
                      className='finishing-img-wrapper'
                      alt={option.alt_text}
                      src={option.img_url}
                    />
                  </div>
                  <div className='tab-lable-container'>{option.name}</div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ height: '66px' }}>
            {activeOption === Constants.CANVAS_FRAME_TYPE_SOLID_COLOR ? (
              <div className='finishing-solid-color' id='finishing'>
                <span className='mr-2'>{string.COLOR_KEY}:</span>
                <UncontrolledDropdown style={{ width: '154px' }}>
                  <DropdownToggle tag='div'>
                    <ReactSelect
                      id='react-select-shadow-dropdown'
                      components={{ Option, SingleValue, IndicatorSeparator }}
                      placeholder={
                        frameColor !== 'none' ? '' : 'Add Frame Color'
                      }
                      isSearchable={false}
                      isDisabled
                      styles={{
                        control: base => ({
                          ...base,
                          '&:hover': { borderColor: 'gray' },
                          border: '1px solid rgb(128, 128, 128)',
                          borderRadius: '0px',
                          boxShadow: 'none',
                          backgroundColor: '#3E3E3E',
                          cursor: 'pointer'
                        }),
                        valueContainer: base => ({
                          ...base,
                          background: `#${frameColor}`,
                          height: '40px'
                        })
                      }}
                    />
                  </DropdownToggle>
                  <DropdownMenu className='shadow-dropdown'>
                    <div className='shadow-colors'>
                      {defaultColors.map((color, index) => (
                        <Label check key={color}>
                          <Input
                            type='radio'
                            name='shadowColor'
                            defaultChecked={index === solidColorIndex}
                            value={color}
                            onClick={e => {
                              e.stopPropagation();
                              this.setFrameColor(e.target.value);
                            }}
                          />
                          <div
                            className='colorBox'
                            style={{ background: color }}
                          />
                        </Label>
                      ))}
                      <Label check>
                        <Input
                          type='radio'
                          onChange={e => {
                            e.stopPropagation();
                            dispatchers.solidColorPickerHandler();
                          }}
                        />
                        <div className='colorBox plus-image' />
                      </Label>
                    </div>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            ) : null}
            {}
          </div>
          <div className={getActiveOrNormalApplyButtonClass()}>
            <button type='button' onClick={this.handleApply}>
              {string.APPLY_KEY}
            </button>
          </div>

          <hr style={{ background: '#7f7f7f' }} />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    defaultColors: state.modal.defaultColors,
    activeTab: state.sideBar.activeMaterialTab,
    canvasFrameType: state.finalCheck.project.canvasFrameType,
    canvasFrameColor: state.finalCheck.project.canvasFrameColor
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: bindActionCreators(actions, dispatch),
    showDialog: bindActionCreators(setMessageDialogParams, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FinishingDetails);
